exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-37173cb8]{color:#fff;font-family:Roboto,sans-serif}.header[data-v-37173cb8]{height:50px;display:flex;align-items:center;justify-content:center}.signUpContainer[data-v-37173cb8]{display:flex;flex-flow:column;align-items:center;justify-content:center;height:300px;font-family:Roboto,sans-serif}.signUpContainer input[type=text][data-v-37173cb8],input[type=password][data-v-37173cb8]{background:#fff;color:#000;padding:10px;border-radius:5px;outline:none;margin-top:20px}.promo[data-v-37173cb8]{color:#fff;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37173cb8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/_mainDirectives/entryComponents/signUpForm.vue
// module id = 456
// module chunks = 0